module.exports = "/_next/static/images/e6bf297af1fb678d17963f3c0a7811f5-girl-and-card-xs.png";